var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditScreenCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 155,
    viewBox: "0 0 153 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2565_9395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.605 277.25C339.493 214.428 339.493 112.573 276.605 49.7501C213.717 -13.0723 111.756 -13.0723 48.8683 49.7501C-14.0194 112.573 -14.0194 214.428 48.8683 277.25C111.756 340.073 213.717 340.073 276.605 277.25Z",
    stroke: "#2A9ED4",
    strokeOpacity: 0.12,
    strokeWidth: 1.95268,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.758 298.232C237.244 298.232 297.626 237.912 297.626 163.504C297.626 89.0963 237.244 28.7766 162.758 28.7766C88.273 28.7766 27.8906 89.0963 27.8906 163.504C27.8906 237.912 88.273 298.232 162.758 298.232Z",
    stroke: "#2A9ED4",
    strokeOpacity: 0.12,
    strokeWidth: 1.95268,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.759 272.056C222.773 272.056 271.424 223.455 271.424 163.504C271.424 103.552 222.773 54.9515 162.759 54.9515C102.745 54.9515 54.0938 103.552 54.0938 163.504C54.0938 223.455 102.745 272.056 162.759 272.056Z",
    stroke: "#2A9ED4",
    strokeOpacity: 0.12,
    strokeWidth: 1.95268,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.899 206.842C256.844 168.142 244.85 117.379 206.11 93.4591C167.371 69.5392 116.555 81.5203 92.6099 120.22C68.665 158.919 80.6587 209.682 119.398 233.602C158.138 257.522 208.954 245.541 232.899 206.842Z",
    stroke: "#2A9ED4",
    strokeOpacity: 0.12,
    strokeWidth: 1.95268,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.753 219.741C193.844 219.741 219.049 194.563 219.049 163.504C219.049 132.445 193.844 107.267 162.753 107.267C131.662 107.267 106.457 132.445 106.457 163.504C106.457 194.563 131.662 219.741 162.753 219.741Z",
    stroke: "#2A9ED4",
    strokeOpacity: 0.12,
    strokeWidth: 1.95268,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2565_9395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 155,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditScreenCarousel);
export default __webpack_public_path__ + "static/media/creditScreenCarousel.0fc0afac0bd5121a11e495cc60c330c7.svg";
export { ForwardRef as ReactComponent };